
import { ApiService } from '../shared/services/api-service/api.service';
import { IAmadeusToken } from './interfaces/amadeus-token-interfaces';

class AmadeusTokenClass {
    async getAmadeusToken(featureName: string, hotelCode: string) {
        try {
            const amadeusPaymentMetaDataResponse: Response = await ApiService.
                getAmadeusToken(featureName, hotelCode);
            const tokenObject: IAmadeusToken = await amadeusPaymentMetaDataResponse.json();
            const tokenString = tokenObject.tokenType + ' ' + tokenObject.accessToken;
            return tokenString;
        } catch (errorResponse) {
            throw errorResponse;
        }
    }
}

export const AmadeusTokenService = new AmadeusTokenClass();
